import defaultsDeep from 'lodash/defaultsDeep'
import Vue from 'vue'
import { dispatcher } from '../dispatcher'
import { FORM_RENDERED_EVENT } from '../module/form/events'
import { stringToCurrencyNumber } from '../../shared/currency'

import '../../../scss/app/staff_development_grant_form.scss'

const expensesModel = {
  registrationsFee: {
    cash: '',
    grant: '',
    applicantCash: '',
  },
  travel: {
    cash: '',
    applicantCash: '',
  },
  accommodations: {
    cash: '',
    applicantCash: '',
  },
  meals: {
    cash: '',
    applicantCash: '',
  },
  other: {
    cash: '',
    applicantCash: '',
  },
  total: {
    cash: '',
    grant: '',
    applicantCash: '',
  },
}

const ExpenseFieldsComponent = {
  template: '#expense-fields-template',

  name: 'ExpenseFields',

  props: ['initialData'],

  data() {
    return {
      expense: null,
    }
  },

  computed: {
    expenseJson() {
      return JSON.stringify(this.expense)
    },
  },

  watch: {
    'expense.registrationsFee.cash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.registrationsFee.grant': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.registrationsFee.applicantCash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.travel.cash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.travel.applicantCash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.accommodations.cash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.accommodations.applicantCash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.meals.cash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.meals.applicantCash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.other.cash': {
      handler() {
        this.updateExpenses()
      },
    },
    'expense.other.applicantCash': {
      handler() {
        this.updateExpenses()
      },
    },
  },

  methods: {
    updateExpenses() {
      if (!this.expense) return

      /* eslint-disable operator-linebreak */

      //
      // Calculate totals
      //

      this.expense.total.cash =
        stringToCurrencyNumber(this.expense.registrationsFee.cash)
        + stringToCurrencyNumber(this.expense.travel.cash)
        + stringToCurrencyNumber(this.expense.accommodations.cash)
        + stringToCurrencyNumber(this.expense.meals.cash)
        + stringToCurrencyNumber(this.expense.other.cash)

      this.expense.total.grant =
        stringToCurrencyNumber(this.expense.registrationsFee.grant)

      this.expense.total.applicantCash =
        stringToCurrencyNumber(this.expense.registrationsFee.applicantCash)
        + stringToCurrencyNumber(this.expense.travel.applicantCash)
        + stringToCurrencyNumber(this.expense.accommodations.applicantCash)
        + stringToCurrencyNumber(this.expense.meals.applicantCash)
        + stringToCurrencyNumber(this.expense.other.applicantCash)

      /* eslint-enable operator-linebreak */
    },
  },

  created() {
    if (this.initialData) {
      const expense = { ...this.initialData }
      defaultsDeep(expense, expensesModel)
      this.expense = expense
    } else {
      this.expense = { ...expensesModel }
    }
  },
}

function setup() {
  new Vue({
    el: '#js-expense-fields',
    name: 'ExpenseFieldsApp',
    components: {
      ExpenseFields: ExpenseFieldsComponent,
    },
  })
}

setup()

dispatcher.addListener(FORM_RENDERED_EVENT, () => {
  setup()
})
